<template>
  <v-app>
    <v-card>
      <v-card-title class="headline justify-center">
        Calendario de citas
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <vue-cal
              :key="calendarKey"
              :time-from="9 * 60"
              :hide-weekdays="[7]"
              :time-to="20 * 60"
              :time-step="30"
              :events="events"
              :default-view="'month'"
              :locale="'es'"
              :disable-views="['years', 'year']"
              :disable-days="disabledDays"
              style="height: 65vh"
              @ready="getDates($event)"
              @view-change="getDates($event)"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-fab-transition>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            fixed
            bottom
            right
            color="primary"
            dark
            v-on="on"
            @click="dialog = !dialog"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Nueva cita</span>
      </v-tooltip>
    </v-fab-transition>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Nueva cita</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  label="Nombre"
                  v-model="formDate.name"
                  autofocus
                />
              </v-col>
              <v-col>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormatted"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateFormatted)"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="date"
                    :value="computedDateFormatted"
                    no-title
                    @input="menu1 = false"
                    :allowed-dates="allowedDates"
                  />
                </v-menu>
              </v-col>
              <v-col>
                <v-text-field
                  label="Hora"
                  type="time"
                  v-model="formDate.time"
                />
              </v-col>
              <v-col>
                <v-text-field v-model="formDate.coupon" label="Cupón" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" dark @click="dialog = false">Cerrar</v-btn>
          <v-btn color="success" @click="saveDate">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import "vue-cal/dist/i18n/es.js";
import "vue-cal/dist/vuecal.css";
import * as moment from "moment";
import VueCal from "vue-cal";

export default {
  components: { VueCal },
  data: (vm) => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu1: false,
    calendarKey: 0,
    dateModal: false,
    dialog: false,
    disabledDays: [],
    endDate: "",
    events: [],
    formDate: {
      name: "",
      date: "",
      time: "",
      coupon: "",
    },
    minDate: moment().format("YYYY-MM-DD"),
    startDate: "",
    timeModal: false,
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedDates(val) {
      const isDisabledDay = this.disabledDays.includes(val);

      if (isDisabledDay) {
        return false;
      }

      if (moment().isAfter(moment(val))) {
        return false;
      }

      return ![6].includes(new Date(val).getDay());
    },
    getDisabledDates() {
      this.sendRequest(`${this.$store.state.apiUrl}settings/disabled-dates`, {
        is_paginated: false,
      })
        .then(({ data }) => {
          this.disabledDays = data.map((event) =>
            moment(event.date).format("YYYY-MM-DD")
          );
        })
        .finally(this.closeLoader());
    },
    getDates(calendarData) {
      this.events = [];
      this.openLoader();
      var datesRequest = this.sendRequest(this.$store.state.apiUrl + "events", {
        start_date: moment(calendarData.startDate).format("YYYY-MM-DD"),
        end_date: moment(calendarData.endDate).format("YYYY-MM-DD"),
      });
      datesRequest
        .then(({ data }) => {
          Object.keys(data).forEach((k) => {
            this.events.push({
              start: data[k].date + " " + data[k].initial_time,
              end: data[k].date + " " + data[k].final_time,
              title: data[k].patient.name,
              class: data[k].color,
            });
          });
        })
        .finally(this.closeLoader());
    },
    saveDate() {
      this.openLoader();
      window.setTimeout(() => {
        const peticion = this.sendRequest(
          this.$store.state.apiUrl + "events",
          {
            ...this.formDate,
            date: this.date,
          },
          "POST"
        );

        peticion
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.dialog = false;
            this.calendarKey++;
          })
          .finally(this.closeLoader());
      }, 200);
    },
  },
  mounted() {
    this.getDisabledDates();
  },
};
</script>

<style>
.non_attendance {
  background-color: #ef5350;
  color: white;
}

.attendance {
  background-color: #66bb6a;
  color: white;
}

.vuecal__cell--disabled {
  text-decoration: line-through;
  color: #bbb;
}
</style>
